export const types = Object.freeze({
  FETCH_ALL: '@industryCertificate/fetchAll',
  SET_CERTIFICATES: '@industryCertificate/setCertificates',
  SET_CERTIFICATE: '@industryCertificate/setCertificate',
  FETCH_ONE: '@industryCertificate/fetchOne',
  SET_LOADING: '@industryCertificate/setLoading'
})

export function fetchAll(
  {
    params = {},
    companyId
  }: { params?: Record<string, any>; companyId: string } = {
    params: {},
    companyId: ''
  }
) {
  return {
    type: types.FETCH_ALL,
    payload: { params, companyId }
  }
}

export function setCertificates({ certificates = {} } = {}) {
  return { type: types.SET_CERTIFICATES, payload: { certificates } }
}

export function fetchOne(id: string) {
  return { type: types.FETCH_ONE, payload: { id } }
}

export function setCertificate({ certificate = {} } = {}) {
  return {
    type: types.SET_CERTIFICATE,
    payload: { certificate, loading: false }
  }
}

export function setLoading({ loading = false } = {}) {
  return { type: types.SET_LOADING, payload: { loading } }
}
